module.exports = __webpack_public_path__ + "img/ic_highlight_off_24.c3022111.svg";